import React from 'react';
import './styles.scss';

const square = (props) => {
	const { styles, children, active, clicked, index, name, value, large, shadow } = props;

	const buttonStyles = {
		...styles,
		cursor: clicked ? 'pointer' : 'default',
	};

	return (
		<button
			style={buttonStyles}
			onClick={clicked}
			data-name={name}
			data-index={index}
			data-value={value}
			className={['Square', active ? 'is-active' : '', large ? 'Square--large' : '', shadow ? 'Square--shaded' : ''].join(' ')}>
			{ children }
		</button>

	)
};

export default square;
